import { render, staticRenderFns } from "./WallLocationsBlockItemSettings.vue?vue&type=template&id=7e5f76b0"
import script from "./WallLocationsBlockItemSettings.vue?vue&type=script&lang=js"
export * from "./WallLocationsBlockItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports